var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrayCoin = function SvgGrayCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.75 7.313a6.562 6.562 0 1 1 13.125 0 6.562 6.562 0 0 1-13.125 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gray_coin_svg__a)",
    fillRule: "evenodd",
    d: "M3.75 7.313a6.562 6.562 0 1 1 13.125 0 6.562 6.562 0 0 1-13.125 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.32 6.053c.145-.17.409-.027.378.194a7.687 7.687 0 0 0 8.68 8.68c.22-.031.364.233.194.378A6.563 6.563 0 0 1 2.32 6.053Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gray_coin_svg__b)",
    d: "M2.32 6.053c.145-.17.409-.027.378.194a7.687 7.687 0 0 0 8.68 8.68c.22-.031.364.233.194.378A6.563 6.563 0 0 1 2.32 6.053Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gray_coin_svg__a",
    x1: 3.229,
    x2: 17.584,
    y1: 15.311,
    y2: 1.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gray_coin_svg__b",
    x1: 3.229,
    x2: 17.584,
    y1: 15.311,
    y2: 1.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })))));
};
export default SvgGrayCoin;